var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_76038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5974 7.5H7.40257C7.03059 7.5 6.67384 7.64777 6.4108 7.9108C6.14777 8.17384 6 8.53059 6 8.90257V25.0974C6 25.4694 6.14777 25.8262 6.4108 26.0892C6.67384 26.3522 7.03059 26.5 7.40257 26.5H23.5974C23.9694 26.5 24.3262 26.3522 24.5892 26.0892C24.8522 25.8262 25 25.4694 25 25.0974V8.90257C25 8.53059 24.8522 8.17384 24.5892 7.9108C24.3262 7.64777 23.9694 7.5 23.5974 7.5ZM11.6631 23.6856H8.80646V14.6118H11.6631V23.6856ZM10.2328 13.3544C9.90875 13.3526 9.59252 13.2548 9.324 13.0734C9.05548 12.892 8.84671 12.6352 8.72403 12.3353C8.60135 12.0353 8.57026 11.7058 8.63469 11.3882C8.69912 11.0707 8.85618 10.7793 9.08604 10.5509C9.3159 10.3225 9.60827 10.1673 9.92624 10.1049C10.2442 10.0426 10.5735 10.0758 10.8727 10.2004C11.1718 10.325 11.4273 10.5354 11.607 10.8051C11.7866 11.0747 11.8823 11.3916 11.8821 11.7156C11.8851 11.9326 11.8445 12.1479 11.7626 12.3488C11.6806 12.5497 11.5591 12.732 11.4052 12.885C11.2513 13.0379 11.0681 13.1583 10.8667 13.2389C10.6653 13.3196 10.4497 13.3588 10.2328 13.3544ZM22.1922 23.6935H19.3369V18.7364C19.3369 17.2744 18.7155 16.8232 17.9133 16.8232C17.0662 16.8232 16.2349 17.4618 16.2349 18.7733V23.6935H13.3783V14.6184H16.1254V15.8758H16.1624C16.4381 15.3177 17.404 14.3638 18.8778 14.3638C20.4717 14.3638 22.1935 15.3098 22.1935 18.0806L22.1922 23.6935Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_76038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(6 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtLinkedinLogo);
export default __webpack_public_path__ + "static/media/at_linkedin_logo.204a6062d1d60fe1253aea0ceb7d991b.svg";
export { ForwardRef as ReactComponent };